import React from 'react';

import { Surface, Surfaces } from '@dx-ui/global-ui-prism';

import { DialogBaseProps, DialogOptionalProps } from './dialog.base';
import { Dialog } from 'radix-ui';
import { ControlClose } from '@dx-ui/osc-controls';
import { useTranslation } from 'next-i18next';

export type DialogFullBleedProps = Omit<
  DialogBaseProps & DialogOptionalProps & { surfaceType?: Surfaces },
  'hasChildrenWithTitle'
>;

export const DialogFullBleedBase: React.FC<React.PropsWithChildren<DialogFullBleedProps>> = ({
  onDismiss,
  isOpen,
  children,
  surfaceType = 'base',
  title,
}) => {
  const { t } = useTranslation('osc-dialog');
  return (
    <Dialog.Root open={isOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-30 size-full">
          <Dialog.Content
            className="fixed inset-0 z-40 size-full"
            onInteractOutside={onDismiss}
            onEscapeKeyDown={onDismiss}
          >
            <Surface type={surfaceType}>
              <div className="fixed inset-0 z-0 bg-surface opacity-95" />
              <div className="fixed inset-0 z-1 flex flex-col overflow-auto">
                {title ? <Dialog.Title className="sr-only">{title}</Dialog.Title> : null}
                <div className="flex w-full flex-col items-end p-4">
                  <ControlClose label={t('close')} onClick={onDismiss} />
                </div>
                <div className="grow">{children}</div>
              </div>
            </Surface>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default DialogFullBleedBase;
